export interface NotificationSettings {
  isEnabled: boolean;
  startTime: {
    hour: number;
    minute: number;
  };
  endTime: {
    hour: number;
    minute: number;
  };
}

export interface PersonalData {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: 'male' | 'female' | 'other';
  countryCode: string;
  phoneCode: string;
  phoneNumber: string;
}

export interface UserProfile {
  id: string;
  email: string;
  personalData?: PersonalData;
  appLanguage?: string;
  unitSystem?: string;
  timezone?: string;
  notifications?: NotificationSettings;
  realmRole?: 'treel-admin' | 'admin' | 'user';
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateProfileRequest {
  personalData?: Partial<PersonalData>;
  appLanguage?: string;
  unitSystem?: string;
  notifications?: Partial<NotificationSettings>;
}

export interface UpdateTimezoneRequest {
  timezone: string;
}

export type AppLanguage = 'en' | 'es' | 'fr' | 'de';
export type UnitSystem = 'metric' | 'imperial';
export type Gender = 'male' | 'female' | 'other';

export const APP_LANGUAGES: Record<AppLanguage, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch'
};

export const UNIT_SYSTEMS: Record<UnitSystem, string> = {
  metric: 'Metric',
  imperial: 'Imperial'
};

export const GENDERS: Record<Gender, string> = {
  male: 'Male',
  female: 'Female',
  other: 'Other'
};